export function formatDateTime(date: Date | string | null): string {
  if (!date) return '-';
  const d = new Date(date);
  const options: Intl.DateTimeFormatOptions = {
    timeZone: 'America/New_York',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  };
  const formatted = d.toLocaleString('en-US', options);
  const isDST = new Date()
    .toLocaleString('en-US', {
      timeZone: 'America/New_York',
      timeZoneName: 'short',
    })
    .includes('EDT');
  return `${formatted} ${isDST ? 'EDT' : 'EST'}`;
}

interface RequestTypeDisplay {
  text: string;
  color: string;
}

export function getRequestTypeDisplay(
  requestType: string | null,
): RequestTypeDisplay {
  if (!requestType) return { text: 'Unknown', color: 'text-neutral-400' };

  const typeMappings: Record<string, RequestTypeDisplay> = {
    NewDapp: { text: 'New Dapp', color: 'text-blue-400' },
    UpdateDapp: { text: 'Update Dapp', color: 'text-yellow-400' },
    RemoveDapp: { text: 'Remove Dapp', color: 'text-red-400' },
    Support: { text: 'Support', color: 'text-green-400' },
    NewRelease: { text: 'New Release', color: 'text-teal-400' },
    UpdateRelease: { text: 'Update Release', color: 'text-orange-400' },
  };

  return (
    typeMappings[requestType] || {
      text: requestType,
      color: 'text-neutral-400',
    }
  );
}

interface StatusBadge {
  text: string;
  bgColor: string;
  textColor: string;
}

export function getMappedStatusBadge(
  status: string | null,
): StatusBadge | null {
  if (!status) return null;

  const statusMappings: Record<string, StatusBadge> = {
    new: {
      text: 'New',
      bgColor: 'bg-blue-900/50',
      textColor: 'text-blue-400',
    },
    in_review: {
      text: 'In Review',
      bgColor: 'bg-yellow-900/50',
      textColor: 'text-yellow-400',
    },
    approved: {
      text: 'Approved',
      bgColor: 'bg-green-900/50',
      textColor: 'text-green-400',
    },
    rejected: {
      text: 'Rejected',
      bgColor: 'bg-red-900/50',
      textColor: 'text-red-400',
    },
    published: {
      text: 'Published',
      bgColor: 'bg-teal-900/50',
      textColor: 'text-teal-400',
    },
    pending: {
      text: 'Pending',
      bgColor: 'bg-orange-900/50',
      textColor: 'text-orange-400',
    },
    blocked: {
      text: 'Blocked',
      bgColor: 'bg-red-900/50',
      textColor: 'text-red-400',
    },
    on_hold: {
      text: 'On Hold',
      bgColor: 'bg-neutral-700/50',
      textColor: 'text-neutral-300',
    },
  };

  const lowerStatus = status.toLowerCase();
  const mapping = statusMappings[lowerStatus];

  if (mapping) {
    return mapping;
  }

  return {
    text: status.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
    bgColor: 'bg-neutral-700/50',
    textColor: 'text-neutral-300',
  };
}
